import { AxiosResponse } from 'axios';
import SnackbarUtils from 'utils/SnackbarUtils';
import { AddToCartProp } from '../../models/Cart';
import {
    QuotationData,
    QuotationProductItem,
} from '../../models/quotations/Quotations';
import { Response } from '../../models/response';
import { api as axiosApi } from '../../utils/axios';
import httpApi from '../api/httpApi';

const useQuotations = () => {
    const COPY_QUOTATION = 'api/v1/offers/copy';
    const QUOTATION = 'api/v1/offers';
    const PDF_CREATE = '/api/v1/offers/pdf';

    const copyQuotation = (quoteId: number): Promise<QuotationData> => {
        return httpApi
            .post<{ offer: QuotationData }>(COPY_QUOTATION, {
                id: quoteId,
            })
            .then((resp) => {
                return resp.getData().offer;
            });
    };

    const deleteQuotation = (quoteId: number): Promise<null> => {
        return httpApi
            .del<null>(QUOTATION, {
                id: quoteId,
            })
            .then((resp) => {
                return resp.getData();
            });
    };

    const createPDFQuotation = (
        quoteId: number,
        use_logo: number
    ): Promise<any> => {
        return axiosApi
            .post(
                PDF_CREATE,
                { offer_id: quoteId, use_logo: use_logo },
                { responseType: 'blob' }
            )
            .then((resp: any) => {
                return Response.createSuccessful<any>(
                    resp.data,
                    resp.status
                ).getData();
            })
            .catch(async (error: AxiosResponse) => {
                SnackbarUtils.error(
                    (
                        JSON.parse(await (error.data as Blob).text()) as {
                            message: string;
                        }
                    ).message
                );

                // globalErrorUtils.handleError(error);
                throw error;
            });
        // return httpApi.get<any>(PDF_CREATE + quoteId).then((resp) => {
        //     return resp.getData();
        // });
    };

    const convertProductsToCart = (
        products: QuotationProductItem[]
    ): AddToCartProp[] => {
        return products.map((elem) => {
            return {
                shopify_variant_id: elem.shopify_variant_id,
                quantity: elem.quantity,
                lineType: 'Item',
            };
        });
    };

    const saveCart = (props: any): Promise<any> => {
        return new Promise(function (resolve, reject) {
            resolve(true);
        });
    };

    return {
        copyQuotation,
        deleteQuotation,
        createPDFQuotation,
        saveCart,
        convertProductsToCart,
    };
};

export default useQuotations;
